import React from "react";
import { useCookies } from "react-cookie";
import { checkAuth } from "./checkAuth";
import { Navigate } from "react-router-dom";

export default function MainRoute({ children }) {
  const [cookies] = useCookies(["token"]);
  const isLogin = checkAuth(cookies.token);
  return <>{isLogin ? children : <Navigate to="/onBoarding" />}</>;
}
